import template from './custom-dropdown.html';

const CustomDropdownComponent = {
    bindings: {
        emptyDisplayName: '<',
        isDisabled: '<',
        itemDisplayProp: '<',
        itemList: '<',
        fieldName: '<',
        onItemSelect: '&',
        isInvalid: '<',
        isRequired: '<',
        selectedDisplay: '<'
    },
    template
};

export default CustomDropdownComponent;



// WEBPACK FOOTER //
// ./app/common/custom-dropdown/custom-dropdown-component.js